var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0992 2.35715C11.6061 2.35715 11.2063 2.75689 11.2063 3.25L11.2063 9.39412H7.58426C7.27482 9.39412 6.98745 9.55435 6.82476 9.81757C6.66208 10.0808 6.64728 10.4095 6.78568 10.6863C7.77529 12.6655 9.72185 14.6121 11.7012 15.6017C11.9525 15.7274 12.2484 15.7274 12.4998 15.6017C14.4789 14.6121 16.4255 12.6655 17.415 10.6863C17.5535 10.4095 17.5387 10.0808 17.376 9.81757C17.2133 9.55435 16.9259 9.39412 16.6165 9.39412H12.992L12.9921 3.25C12.9921 2.75689 12.5923 2.35715 12.0992 2.35715ZM4.84941 16.1103C4.77196 15.4243 4.15308 14.9309 3.46708 15.0084C2.78107 15.0858 2.28774 15.7047 2.36518 16.3907C2.50722 17.649 3.07136 18.822 3.96561 19.7186C4.85985 20.615 6.03143 21.1821 7.28935 21.3274L7.29341 21.3279C8.79196 21.4959 10.3722 21.6441 12.0002 21.6441C13.6281 21.6441 15.2097 21.4959 16.707 21.3279L16.711 21.3274C17.9689 21.1821 19.1405 20.615 20.0347 19.7186C20.9289 18.822 21.493 17.649 21.6352 16.3907C21.7126 15.7047 21.2192 15.0858 20.5332 15.0084C19.8472 14.9309 19.2283 15.4243 19.1509 16.1103C19.0723 16.807 18.7599 17.4566 18.2647 17.953C17.7699 18.449 17.1219 18.7629 16.426 18.8437C14.9533 19.009 13.4841 19.1441 12.0002 19.1441C10.5163 19.1441 9.04855 19.009 7.57422 18.8437C6.87838 18.7629 6.23035 18.449 5.73561 17.953C5.24043 17.4566 4.92805 16.807 4.84941 16.1103Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.a246474b.svg";
export { ForwardRef as ReactComponent };